import api from './index';
import type { Set, CreateSetRequest, UpdateSetRequest } from '@/types/set';
import type { SetsResponse } from '@/types/api';

/**
 * List sets for the current user.
 */
export async function getSets(params?: { status?: string }): Promise<SetsResponse> {
  const response = await api.get<SetsResponse>('/sets', { params });
  return response.data;
}

/**
 * Get full set details.
 */
export async function getSet(setId: string): Promise<Set> {
  const response = await api.get<Set>(`/sets/${setId}`);
  return response.data;
}

/**
 * Create a new set.
 */
export async function createSet(data: CreateSetRequest): Promise<Set> {
  const response = await api.post<Set>('/sets', data);
  return response.data;
}

/**
 * Update a set (name, description, or status).
 */
export async function updateSet(setId: string, data: UpdateSetRequest): Promise<Set> {
  const response = await api.patch<Set>(`/sets/${setId}`, data);
  return response.data;
}

/**
 * Delete (archive) a set.
 */
export async function deleteSet(setId: string): Promise<Set> {
  const response = await api.delete<Set>(`/sets/${setId}`);
  return response.data;
}
